/**
 * App-wide "you have unsaved changes" guard (2026-09-20).
 *
 * A single module-level flag, not React state/context -- whichever page
 * currently has an editable form calls `setHasUnsavedChanges` as its own
 * dirty state changes, and clears it back to `false` on save/cancel/
 * unmount. `confirmLeaveIfDirty` is checked at every real "leave" point
 * the app has: Settings' own tab switcher (features/settings/page.tsx)
 * and the main sidebar/mobile-drawer's shared navigation hook
 * (use-navigation-state.ts) -- both call through this same function, so
 * there's one confirm dialog, one place that owns the flag, and no
 * cross-component prop/ref plumbing to keep in sync.
 */
let hasUnsavedChanges = false;

export function setHasUnsavedChanges(value: boolean): void {
  hasUnsavedChanges = value;
}

/** Returns true if it's fine to proceed (nothing dirty, or the user confirmed losing it). */
export function confirmLeaveIfDirty(): boolean {
  if (!hasUnsavedChanges) return true;
  return window.confirm('Are you sure you want to lose all unsaved progress?');
}
